import Swal from "sweetalert2";
import { FilterUser, FilterUserDto, TableParams, UserType } from "../types";
import { getTableConfig, saveTableConfig } from "../../../../components/ModularDataTable/utils/persistConfig";
import { useEffect, useState } from "react";
import { GET_ADM, POST_ADM } from "../../../../services/api";


export function useUsers(pluginspaceId: string,persistPageKey_?: string, persistContextKey_?: string) {
    
    const persistPageKey = persistPageKey_ || 'swagger_permissions_pluginspace_users';
    const persistContextKey = persistContextKey_ || 'swagger_permissions_pluginspace_users';


    const [users, setUsers] = useState<UserType[]>([])
    const [loading, setLoading] = useState(false)
    const [tableLoading, setTableLoading] = useState(false)

    // Carrega persistido
    const persisted = getTableConfig(persistPageKey, persistContextKey) || {};

    const [pagination, setPagination] = useState({
        page: persisted.pagination?.page || 1,
        pageSize: persisted.pagination?.pageSize || 10,
        total: 0,
        pageSizes: [10, 25, 50, 100],
    })
    const [sorting, setSorting] = useState({
        field: persisted.sorting?.field || 'id',
        direction: persisted.sorting?.direction || 'asc',
    })
    const [searchTerm, setSearchTerm] = useState(persisted.filters?.search || '')
    const [usersFilters, setUsersFilters] = useState<FilterUserDto>(persisted.filters || {})


    
    // Sempre que filtros, paginação ou sorting mudarem, salva tudo junto
    useEffect(() => {
        saveTableConfig(persistPageKey, persistContextKey, {
            filters: usersFilters,
            pagination,
            sorting,
        })
    }, [usersFilters, pagination, sorting])

    const handlePaginationChange = (newPagination: any) => {
        setPagination(newPagination)
        getUsers({
            page: newPagination.page,
            pageSize: newPagination.pageSize,
            search: searchTerm,
            sorting: sorting.field ? sorting : undefined,
        })
    }

    const handleSortingChange = (newSorting: any) => {
        setSorting(newSorting)
        getUsers({
            page: pagination.page,
            pageSize: pagination.pageSize,
            search: searchTerm,
            sorting: newSorting,
        })
    }

    const handleDataChange = async (params: {
        page: number
        pageSize: number
        search: string
        sorting?: { field: string; direction: 'asc' | 'desc' }
        filters?: any
    }) => {
        setPagination((prev) => ({ ...prev, page: params.page, pageSize: params.pageSize }))
        if (params.sorting) setSorting(params.sorting)
        setSearchTerm(params.search)
        if (params.filters) setUsersFilters(params.filters)
        await getUsers(params)
    }

    function translateFilter(data: FilterUserDto): FilterUser {
        const status = (!data.status || data.status?.value === 2) ? undefined : data.status?.value === 1 ? true : false;
        const type = data.type?.value === 'all' ? undefined : data.type?.value

        return {
            type,
            status,
        };
    }

    async function getUsers(params?: TableParams) {
        try {
            setTableLoading(true)
            const currentPage = params?.page || pagination.page
            const currentPageSize = params?.pageSize || pagination.pageSize
            const currentSearch = params?.search || searchTerm
            const currentSorting = params?.sorting || sorting

            const query = `?field=${currentSorting.field}&order=${currentSorting.direction.toUpperCase()}&page=${currentPage - 1}&take=${currentPageSize}&search=${currentSearch}`


            const currentFilters = translateFilter(params?.filters ?? usersFilters)

            const request = await GET_ADM(`users/pluginspace/${pluginspaceId}${query}`)

            if (!request.data) {
                console.warn('[getPluginSpaces] Nenhum dado retornado da API!')
            }
            const mappedUsers = request.data
            setUsers(mappedUsers)

            if (request.meta) {
                const paginagionInfo = {
                    total: request.meta.itemCount,
                    page: currentPage,
                    pageSize: currentPageSize,
                }
                setPagination((prev) => ({
                    ...prev,
                    ...paginagionInfo,
                }))
                console.log('[getUsers] Paginação atualizada:', paginagionInfo)
            }
            return mappedUsers

        } catch (error) {
            console.log('[getUsers] Erro:', error)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Um erro ocorreu ao filtrar os usuários. Por favor, tente novamente.',
            })
            return []
        } finally {
            setTableLoading(false)
        }
    }



    return {
        users,
        pagination,
        sorting,
        searchTerm,
        usersFilters,
        loading,
        tableLoading,
        getUsers,
        handleDataChange,
        handlePaginationChange,
        handleSortingChange,
        setLoading,
    }
}